const initialState = {
  identifier: "unset",
  activeSubMenu: undefined,
};

export default initialState;
